export default __webpack_public_path__ + "static/LP-Filter-pattern-74016b07348c9bc9ac4a101c2fd05958.gif";